// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'

import EmployerVenueAreaDetail from 'syft-acp-core/entities/EmployerDetail/EmployerVenueAreaDetail'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'

const EmployerVenueAreaView = ({ match: { params } }) => {
  const employerName = useEmployerName(Number(params.id))

  return (
    <PageTitle
      title={[
        `Area ${params.areaID}`,
        `Venue ${params.venueID}`,
        recordLabel('Employer', params.id, employerName),
      ]}
    >
      <div>
        <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
        {/* Note: we need to send the venueID as 'id', because that's how we will find the store data. */}
        <EmployerVenueAreaDetail
          id={Number(params.venueID)}
          employerID={Number(params.id)}
          areaID={Number(params.areaID)}
        />
      </div>
    </PageTitle>
  )
}

EmployerVenueAreaView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      areaID: PropTypes.string.isRequired,
      venueID: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerVenueAreaView
